import axios from '@axios'

export default {
  namespaced: true,
  state:()=>({
    root:null,
    loadings:0,
    readOnly:false,
    id:null,
    name:null,
    device_id:null,
    deviceOptions:[],
    type:'distance',
    limit:0,
    historyList:[],
    event_id:null,
    errors:[]
  }),
  mutations:{
    updateRoot(state, payload){
      state.root = payload
    },
    startLoadingState(state){
      state.loadings += 1;
    },
    stopLoadingState(state){
      state.loadings -= 1;
    },
    activateReadOnlyMode(state){
      state.readOnly = true
    },
    updateId(state, payload){
      state.id = payload.value
    },
    updateName(state, payload){
      state.name = payload.value
    },
    updateDeviceId(state, payload){
      state.device_id = payload.value
    },
    updateDeviceOptions(state, payload){
      state.deviceOptions = payload
    },
    updateType(state, payload){
      state.type = payload.value
    },
    updateLimit(state, payload){
      state.limit = payload.value
    },
    updateHistoryList(state, payload){
      state.historyList = payload
    },
    updateEventId(state, payload){
      state.event_id = payload.value
    },
    updateErrors(state, payload){
      state.errors = payload
    }
  },
  actions: {
    create({ getters, commit }){
      commit('startLoadingState')
      axios.post('maintenances', { 
        ...(getters.fields.includes('name') && {name: getters.name}),
        ...(getters.fields.includes('device_id') && {device_id: getters.device_id}),
        ...(getters.fields.includes('type') && {type: getters.type}),
        ...(getters.fields.includes('limit') && {limit: getters.limit}),
      })
      .then(response => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('MAINTENANCES_CREATE_SUCCESS_MESSAGE'), {
            variant: 'success',
        })
        getters.root.$router.push({ name: 'maintenances.edit', params: { id: response.data.maintenance.id } })
      })
      .catch( reason => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('MAINTENANCES_CREATE_FAILURE_MESSAGE'), {
          variant: 'danger'
        })
        commit('updateErrors' , reason.response.data.errors)
      })
      .finally(() => commit('stopLoadingState'))
    },
    update({ getters, commit, dispatch }){
      commit('startLoadingState')
      axios.put(`maintenances/${getters.id}`, {
        ...(getters.fields.includes('name') && {name: getters.name}),
        ...(getters.fields.includes('device_id') && {device_id: getters.device_id}),
        ...(getters.fields.includes('type') && {type: getters.type}),
        ...(getters.fields.includes('limit') && {limit: getters.limit}),
      })
      .then(response => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('MAINTENANCES_UPDATE_SUCCESS_MESSAGE'), {
            variant: 'success',
        })
        dispatch('load', {id:getters.id})
      })
      .catch( reason => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('MAINTENANCES_UPDATE_FAILURE_MESSAGE'), {
          variant: 'danger'
        })
        commit('updateErrors' , reason.response.data.errors)
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchOptions({ dispatch }){
      dispatch('fetchDeviceOptions')
    },
    fetchDeviceOptions({ commit, rootGetters }){
      commit('startLoadingState')
      axios.get('userGetLinked', { params:{
        type: 'device',
        user:rootGetters['auth/user']['id']
      }})
      .then(r => {
          commit('updateDeviceOptions', r.data.data)
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('MAINTENANCES_DEVICE_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    load({ commit, getters }, payload ){
      commit('startLoadingState')
      axios.get(`maintenances/${payload.id}`)
      .then(response => {
            commit('updateId', {value:response.data.maintenance.id})
            commit('updateName', {value:response.data.maintenance.name})
            commit('updateDeviceId', {value:response.data.maintenance.device_id})
            commit('updateType', {value:response.data.maintenance.type})
            commit('updateLimit', {value:response.data.maintenance.limit})
            commit('updateHistoryList', response.data.maintenance.history)
            commit('stopLoadingState')
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('MAINTENANCES_LOAD_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
    },
    loadFromRoute({ getters, dispatch }){
      dispatch('load', {id:getters.root.$router.currentRoute.params.id})
    }
  },
  getters:{
    root(state){
      return state.root
    },
    isLoading(state){
      return state.loadings > 0
    },
    isReadOnly(state){
      return state.readOnly
    },
    fields(state){
      return [
        'name',
        'device_id',
        'type',
        'limit'
      ]
    },
    errors(state){
      return state.errors
    },
    id(state){
      return state.id
    },
    name(state){
      return state.name
    },
    device_id(state){
      return state.device_id
    },
    deviceOptions(state){
      return state.deviceOptions
    },
    type(state){
      return state.type
    },
    typeOptions(state, getters){
      return [
        {
          id:'distance',
          name: getters.root.$i18n.t('MAINTENANCES_TYPE_DISTANCE_LABEL')
        },
        {
          id:'duration',
          name: getters.root.$i18n.t('MAINTENANCES_TYPE_DURATION_LABEL')
        }
      ]
    },
    unit(state, getters){
      switch(state.type){
        case 'distance': return getters.root.$i18n.t('MAINTENANCES_TYPE_DISTANCE_UNIT_LABEL')
        case 'duration' : return getters.root.$i18n.t('MAINTENANCES_TYPE_DURATION_UNIT_LABEL')
      }
    },
    limit(state){
      return state.limit
    },
    limitLabel(state, getters){
      return `${ getters.root.$i18n.t('MAINTENANCES_LIMIT_LABEL') } (${ getters.unit })`
    },
    historyList(state){
      return state.historyList
    },
    historyTableColumns(state, getters){
      return [
        { 
          key: 'time',
          label: getters.root.$i18n.t('MAINTENANCES_HISTORY_TIME_LABEL')
        },
        {
          key: 'event',
          label: getters.root.$i18n.t('MAINTENANCES_HISTORY_EVENT_LABEL'),
          formatter:(value)=>{
              return getters.root.$i18n.t(value)
          }
        },
        {
          key: 'user',
          label: getters.root.$i18n.t('MAINTENANCES_HISTORY_USER_LABEL')
        },
        {
          key: 'details',
          label: getters.root.$i18n.t('MAINTENANCES_HISTORY_DETAILS_LABEL')
        }
      ]
    },
    event_id(state){
      return state.event_id
    },
    event(state, getters){

      let event = state.historyList.find(event => event.id === getters.event_id)

      if(event === undefined){
        event = {
          id: null,
          time: '',
          user: '',
          event: '',
          attributes: []
        }
      }
      
      return event
    },
    eventTableValueFormatter:(state, getters) => (value, key, item) => {

      if(item.field == 'type'){
        switch(value){
            case 'distance': 
                return getters.root.$i18n.t('MAINTENANCES_TYPE_DISTANCE_LABEL')
            case 'duration': 
              return getters.root.$i18n.t('MAINTENANCES_TYPE_DURATION_LABEL')
        }
      }

      return value;
    },
    eventTableColumns(state, getters){

      switch(getters.event.type){
        case 'created' : return [
          { 
            key: 'field',
            label: getters.root.$i18n.t('MAINTENANCES_HISTORY_FIELD_LABEL'),
            formatter:(value)=>{
              return getters.root.$i18n.t(value)
            }
          },
          {
            key: 'value',
            label: getters.root.$i18n.t('MAINTENANCES_HISTORY_VALUE_LABEL'),
            formatter: getters.eventTableValueFormatter
          }
        ]

        case 'updated' : return [
          { 
            key: 'field',
            label: getters.root.$i18n.t('MAINTENANCES_HISTORY_FIELD_LABEL'),
            formatter:(value)=>{
              return getters.root.$i18n.t(value)
            }
          },
          {
            key: 'oldValue',
            label: getters.root.$i18n.t('MAINTENANCES_HISTORY_OLD_VALUE_LABEL'),
            formatter: getters.eventTableValueFormatter
          },
          {
            key: 'newValue',
            label: getters.root.$i18n.t('MAINTENANCES_HISTORY_NEW_VALUE_LABEL'),
            formatter: getters.eventTableValueFormatter
          }
        ]

        case 'done' : return [
          { 
              key: 'field',
              label: getters.root.$i18n.t('MAINTENANCES_HISTORY_FIELD_LABEL'),
              formatter:(value)=>{
                return getters.root.$i18n.t(value)
              }
            },
            {
              key: 'value',
              label: getters.root.$i18n.t('MAINTENANCES_HISTORY_VALUE_LABEL'),
              formatter: getters.eventTableValueFormatter
            }
        ]

        default : return []
      }
    }
  }
}
